import {useQuery} from 'react-query';
import getCheckContactLimit from '.';

const useGetCheckContactLimit = (guid: string, isShop: boolean) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['check-contact-limit', guid],

    queryFn: () => getCheckContactLimit(guid),
    enabled: false,
  });
  return {data, isLoading, refetch, isShop};
};

export default useGetCheckContactLimit;
